import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mv_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const ws = localStorage.getItem("mv_workspace");
  if (ws) {
    try {
      const id = JSON.parse(ws).id;
      if (id) cfg.headers["X-Workspace-Id"] = id;
    } catch (e) {
      /* ignore */
    }
  }
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
